import { render, staticRenderFns } from "./peopleUser.vue?vue&type=template&id=c890abc6&scoped=true"
import script from "./peopleUser.vue?vue&type=script&lang=js"
export * from "./peopleUser.vue?vue&type=script&lang=js"
import style0 from "./peopleUser.vue?vue&type=style&index=0&id=c890abc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c890abc6",
  null
  
)

export default component.exports